import React from 'react';
import { useTranslation } from 'next-i18next';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
  CarouselDots,
} from '@lb-service/ui';
import TestimonialItem from './Item';

const TestimonialsSlider = () => {
  const { t } = useTranslation('common');
  const maximProps = {
    photoUrl: '/images/maxim.jpg',
    quote: t('service.home.testimonials.maxim.quote'),
    profile: t('service.home.testimonials.maxim.profile'),
    occupation: 'Software Engineer',
  };
  const juanProps = {
    photoUrl: '/images/juan.jpg',
    quote: t('service.home.testimonials.juan.quote'),
    profile: t('service.home.testimonials.juan.profile'),
    occupation: 'SFE Analyst',
  };
  const wakiProps = {
    photoUrl: '/images/waki.jpg',
    quote: t('service.home.testimonials.waki.quote'),
    profile: t('service.home.testimonials.waki.profile'),
    occupation: 'HR Professional',
  };
  return (
    <Carousel opts={{ loop: true }}>
      <CarouselContent>
        <CarouselItem>
          <TestimonialItem {...maximProps} />
        </CarouselItem>
        <CarouselItem>
          <TestimonialItem {...juanProps} />
        </CarouselItem>
        <CarouselItem>
          <TestimonialItem {...wakiProps} />
        </CarouselItem>
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
      <CarouselDots />
    </Carousel>
  );
};

export default TestimonialsSlider;
